<ng-permit-search-dialog
  *ngIf="(store$ | async) as store"
  [commodities]="store.commodities"
  [permits]="store.permitsFound"
  [searchingPermits]="store.searchingPermits"
  (searchPermits)="searchPermits($event)"
  (loadPermit)="loadPermit($event)">
</ng-permit-search-dialog>
